import { render, staticRenderFns } from "./AssetAvatar.vue?vue&type=template&id=a07c7d30&scoped=true&"
import script from "./AssetAvatar.vue?vue&type=script&lang=js&"
export * from "./AssetAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AssetAvatar.vue?vue&type=style&index=0&id=a07c7d30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07c7d30",
  null
  
)

export default component.exports